import Payment from './Payment';
import Filter  from './Filter';
import Body    from './Body'  ;

type IComponents = {
  Payment: typeof Payment;
  Filter : typeof Filter;
  Body   : typeof Body  ;
}

const Components: IComponents = {
  Payment,
  Filter,
  Body,
}

export default Components;
